import { render, staticRenderFns } from "./DataStaDetail.vue?vue&type=template&id=2ebeeac8&scoped=true"
import script from "./DataStaDetail.vue?vue&type=script&lang=js"
export * from "./DataStaDetail.vue?vue&type=script&lang=js"
import style0 from "./DataStaDetail.vue?vue&type=style&index=0&id=2ebeeac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebeeac8",
  null
  
)

export default component.exports